import { useState } from 'react';

interface BilingualArrayItem {
  en: string;
  id: string;
}

interface BilingualArrayFieldProps {
  label: string;
  items: BilingualArrayItem[];
  onChange: (items: BilingualArrayItem[]) => void;
}

export function BilingualArrayField({ label, items, onChange }: BilingualArrayFieldProps) {
  const [newEn, setNewEn] = useState('');
  const [newId, setNewId] = useState('');

  const addItem = () => {
    if (newId.trim() || newEn.trim()) {
      onChange([...items, { en: newEn.trim(), id: newId.trim() }]);
      setNewEn('');
      setNewId('');
    }
  };

  const removeItem = (index: number) => {
    onChange(items.filter((_, i) => i !== index));
  };

  const updateItem = (index: number, lang: 'en' | 'id', value: string) => {
    const updated = [...items];
    updated[index] = { ...updated[index], [lang]: value };
    onChange(updated);
  };

  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">{label}</label>
      <div className="space-y-2">
        {items.map((item, index) => (
          <div key={index} className="flex gap-2 items-start">
            <div className="flex-1 space-y-1">
              <div className="flex items-center gap-1">
                <span className="text-xs font-medium text-gray-500 w-6">ID</span>
                <input
                  type="text"
                  value={item.id}
                  onChange={(e) => updateItem(index, 'id', e.target.value)}
                  className="flex-1 border rounded px-2 py-1 text-sm"
                  placeholder="Indonesian"
                />
              </div>
              <div className="flex items-center gap-1">
                <span className="text-xs font-medium text-gray-500 w-6">EN</span>
                <input
                  type="text"
                  value={item.en}
                  onChange={(e) => updateItem(index, 'en', e.target.value)}
                  className="flex-1 border rounded px-2 py-1 text-sm"
                  placeholder="English"
                />
              </div>
            </div>
            <button
              type="button"
              onClick={() => removeItem(index)}
              className="text-red-500 hover:text-red-700 text-sm mt-1"
            >
              ×
            </button>
          </div>
        ))}
      </div>
      <div className="mt-2 flex gap-2 items-end">
        <div className="flex-1 space-y-1">
          <input
            type="text"
            value={newId}
            onChange={(e) => setNewId(e.target.value)}
            placeholder="New item (ID)"
            className="w-full border rounded px-2 py-1 text-sm"
          />
          <input
            type="text"
            value={newEn}
            onChange={(e) => setNewEn(e.target.value)}
            placeholder="New item (EN)"
            className="w-full border rounded px-2 py-1 text-sm"
            onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); addItem(); } }}
          />
        </div>
        <button type="button" onClick={addItem} className="px-3 py-1 bg-blue-600 text-white rounded text-sm hover:bg-blue-700">Add</button>
      </div>
    </div>
  );
}
